import React, { DetailedHTMLProps, HTMLAttributes, useEffect } from 'react';
import styles from './Modal.module.sass';
import ReactDOM from 'react-dom';

const Modal = React.forwardRef(({
    isOpen,
    children,
    size,
    ...props
}: Props, ref: any) => {
    useEffect(() => {
        if (isOpen === undefined) {
            document.body.style.overflow = 'hidden';
        }
        
        return () => {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen]);

    if (isOpen !== undefined && !isOpen) return <></>;

    return ReactDOM.createPortal(
        <div
            className={styles['modal__wrapper']}
            ref={ref}
            {...props}
        >
            <div className={`${styles['modal']} ${styles['modal__size--'+(size||'medium')]}`}>
                { children }
            </div>
        </div>,
        // @ts-ignore
        document.getElementById('root')
    );
});

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>,HTMLDivElement> {
    isOpen?: boolean
    size?: 'small' | 'medium' | 'large' | 'xlarge'
}

export default Modal;